import React, {useCallback} from 'react';
import {isAllParticipantsFilterTabSelected} from './isAllParticipantsFilterTabSelected';
import {useI18n} from '../../../../../../data/hooks/i18nHooks';
import Tab from '../../../../../elements/Tabs/Tab';
import {useDispatch} from 'react-redux';
import {useRecommendedParticipantsFilter} from '../../../../../../data/hooks/participant/useRecommendedParticipantsFilter';

const ALL_PARTICIPANTS_FILTER = {};

function AllParticipants(props) {
    const {className = '', eventId, filterParams} = props,
        suggestedFilterParams = useRecommendedParticipantsFilter(eventId),
        selected = isAllParticipantsFilterTabSelected(filterParams, suggestedFilterParams),
        i18n = useI18n(),
        dispatch = useDispatch();

    const handleClick = useCallback(() => {
        dispatch(app.actions.participants.setFilterParams(eventId, ALL_PARTICIPANTS_FILTER));
    }, [eventId]);

    return (
        <Tab className={className} selected={selected} onClick={handleClick}>
            {i18n['label.tab.all']}
        </Tab>
    );
}

export default AllParticipants;
